import { useState, useEffect } from 'react';
import { subjects } from '../helpers';

export const useGlobalState = subjectName => {
  const subject = subjects[subjectName];
  const [value, setValue] = useState(subjectName && subject.getValue());

  useEffect(() => {
    if (subject) {
      const sub = subject.subscribe(s => setValue(s));
      return () => sub.unsubscribe();
    }
  });

  const newSetValue = newValue => {
    subject.next(newValue);
  };
  return [value, newSetValue];
};
